module.exports = __webpack_public_path__ + "static/img/contextual-recruitment-aus.857fab9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/research/contextual-recruitment-aus.png
// module id = gn2U
// module chunks = 0